import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {EmitterService} from '../../service/EmitterService';
import {_} from 'underscore';
import {BlockService} from '../../service/BlockService';
import {MotifVO} from '../../model/MotifVO';
import {MotifService} from '../../service/MotifService';
import {SessionService} from '../../service/SessionService';
import * as moment from 'moment';
import {ConfirmatonDialogComponent} from '../block-temps/confirmaton-dialog/confirmaton-dialog.component';
import {isUndefined} from 'util';
import {AlertService} from '../../service/alert.service';
import {TimeZoneService} from '../../service/TimeZoneService';
import {RoleService} from '../../service/RoleService';
import {
  DATE_TIME_AT_8_0_0,
  DATE_TIME_AT_18_0_0,
  DATE_TIME_AT_0_0_0,
  DATE_TIME_AT_23_59_59,
  DATE_DEFAULT_FORMAT,
  DATE_TIME_FORMAT, DATE_D_M_Y_SLASH_FORMAT
} from '../../model/commons/DateConstants';
import {UUID} from 'angular2-uuid';
import {FindValueSubscriber} from 'rxjs/operators/find';
import {IS_PLANNED, IS_REALISE} from '../../helpers/GlobalConstants';

@Component({
  selector: 'app-insert-realise-dialog',
  templateUrl: 'insert-realise-dialog.component.html',
  styleUrls: ['./insert-realise-dialog.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class InsertRealiseDialogComponent implements OnInit {
  isFormation: any;
  formatTime: any = 0;
  incoherencesOld: any = [];
  incoherences: any;
  motifs: Array<MotifVO> = null;
  updateBlock: Array<any> = [];
  breakOverflowErroMsg = '';
  dataMotif: any;
  isUpdated: any = false;
  enableButton = true;
  defaultMotif;
  lockUser: any;
  isUpdatedBlocks = false;
  user = null;
  typeMotif = {
    INCOHERENCE_INSERVICE: 'PLUS',
    INCOHERENCE_OFFSERVICE: 'MINUS'
  };
  overFlowBreaksMotifs = ['BREAKOVERFLOW', 'INCIDENTTECH', 'OUBLIEARRETPAUSE', 'TRAVAILNONLOGUE', 'VISITEMED'];
  userValidatedBy = null;
  dateTimeRangeIsDisplayed: false;
  public motifExeception = [{code: 'PAUSE', label: 'En Pause '}, {code: 'DELOG', label: 'Hors Service'}, {
    code: 'REALISE',
    label: 'En Service'
  }];
  public index = null;
  constructor(
    private blockservice: BlockService,
    private emit: EmitterService,
    public dialogRef: MatDialogRef<InsertRealiseDialogComponent>,
    private motifservice: MotifService,
    private session: SessionService,
    private alertService: AlertService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private tzService: TimeZoneService,
    private roleService: RoleService) {
    tzService.setUser(data.user.username);
    this.user = data.user;
    this.isFormation = data.isFormation;
    this.userValidatedBy = data.temps.map(e => e.validatedBy).filter(e => e !== null);
    if (this.userValidatedBy.length > 0) {
      this.userValidatedBy = this.userValidatedBy[0];
    } else {
      this.userValidatedBy = null;
    }
    // console.log(this.userValidatedBy)
    /*    motifservice.getMotif().subscribe((r: any) => {
          let d: any;
          d = r
          this.motifs = d.map((e, i) => {
            return {value: e.code, text: e.label, type: e.type};
          });
        },
          error1 => { this.session.redirectBadRequest(error1);})*/
    console.error('BREAK 1:', data.breaks);
    const breaks = data.breaks.filter(e => moment(e.date, DATE_D_M_Y_SLASH_FORMAT).format(DATE_DEFAULT_FORMAT) === this.blockservice.currentDate).map(d => {
      return {
        id: d.id,
        motif: 'PAUSE',
        newMotif: 'PAUSE',
        start: moment(new Date(d.start + 'Z')).toDate(),
        end: moment(new Date(d.end + 'Z')).toDate(),
        uid: moment(new Date(d.start + 'Z')).toDate().getTime(),
        updated: false,
        type: 'FULFILLED',
        activityType: d.activityType,
        duration: d.duration,
        time: d.duration,
        'break': d.break
      };
    });
    const breakUUID = breaks.map(e => {
      return this.generateUUID(e.start, e.end)
    })
    data.temps = data.temps.filter((block: any) => {
      const uid = this.generateUUID(block.start, block.end);
      console.error('generateUUID:', uid, breakUUID);
      return !breakUUID.includes(uid);
    });
/*    breaks = breaks.map((block) => {
      e.start = moment(new Date(e.start + 'Z')).toDate();
      e.end = moment(new Date(e.end + 'Z')).toDate();
      return e;
    });*/
    console.error('BREAK 2:', breaks);
    const user = JSON.parse(localStorage.getItem('INTELCIA_OAUTH_REMOTE_USER'));
    console.log('data temps data', data.temps);
    this.incoherences = data.temps.filter(b => IS_REALISE(b)).map((d, i) => {
      return {
        id: d.id,
        motif: d.motif && d.newMotif != 'REALISE' && d.newMotif != 'DELOG' && d.newMotif != 'PAUSE' ? d.motif : d.newMotif,
        newMotif: 'REALISE',
        start: d.start,
        end: d.end,
        uid: moment(d.start).toDate().getTime(),
        updated: false,
        type: d.type,
        activityType: d.activityType,
        duration: null,
        time: null,
        break: null
      };
    });
    this.incoherences = this.incoherences.concat(breaks);
    this.incoherences = _.sortBy(_.uniq(this.incoherences, 'start'), x => x.start);
    console.log('incoherencesfff', this.incoherences, breaks);

    /*this.incoherences = data.temps.map((d, i) => {
      let block = {
        id: d.id,
        motif: d.motif,
        start: d.start,
        end: d.end,
        uid: (d.start !== undefined ? new Date(d.start).getTime() : new Date().getTime() ),
        updated: false,
        type: d.type,
        duration: d.duration,
        time: d.duration,
        'break': d.break,
        locked: d.locked,
        activityType: d.activityType,
        blockStatus: d.blockStatus,
        label: d.label,
        timeZone: d.timeZone,
        user: d.user,
        logged: d.logged,
        tag: d.tag,
        durationBreak: d.durationBreak,
        validatedBy: d.validatedBy,
        reclamationStatus: d.reclamationStatus,
        source: d.source,

        updatedBy: (user ? user.username : null)
      };
      if(d.motif) {
        block['motif'] = {'code': d.motif.code, 'label': d.motif.label, 'type': d.motif.type};
      }
      return block
    });*/
    // if(data.fromAddRealiseValide){
    //   this.incoherences.push({
    //     id: null,
    //     motif: {code: "ARRIVEEANTICIPEE", label: "Arrivée Anticipée", type: "PLUS", paied: false},
    //     start: moment(moment(this.blockservice.currentDate).format(DATE_TIME_AT_8_0_0)).toDate(),
    //     end: moment(moment(this.blockservice.currentDate).format(DATE_TIME_AT_18_0_0)).toDate(),
    //     uid: UUID.UUID(),
    //     updated: false,
    //     type: 'INCOHERENCE_FREE',
    //     duration: null,
    //     time: null,
    //     break: null
    //   })
    // }
    const freeIncoherences = [];
    let firstFreeIncoherence = null, lastFreeIncoherence = null;
    this.incoherences = _.sortBy(this.incoherences, 'start');
    this.incoherencesOld = JSON.parse(JSON.stringify(this.incoherences));
    // console.log('avant ==================>', this.incoherences)
    //this.incoherences = this.incoherences.filter((inco, i) => ((this.incoherences[i + 1] && moment(this.incoherences[i + 1].start).diff(inco.start, 'minute') != 0) || !this.incoherences[i + 1]) && inco.type != 'PLANNED_INSERVICE' && inco.type != 'PLANNED_OFFSERVICE');
    const start = moment(moment(this.blockservice.currentDate).format(DATE_TIME_AT_0_0_0)).toDate();
    const end = moment(moment(this.blockservice.currentDate).format(DATE_TIME_AT_23_59_59)).toDate();
    firstFreeIncoherence = {
      id: null,
      motif: {code: 'ARRIVEEANTICIPEE', label: 'Arrivée Anticipée', type: 'PLUS', paied: false},
      start: start,
      end: this.incoherences.length > 0 ? this.incoherences[0].start : end,
      uid: start.getTime(),
      updated: false,
      type: 'INCOHERENCE_FREE',
      activityType: 'OFFSERVICE',
      duration: null,
      time: null,
      break: null
    };
    freeIncoherences.push(firstFreeIncoherence);
    lastFreeIncoherence = {
      id: null,
      motif: {code: 'ARRIVEEANTICIPEE', label: 'Arrivée Anticipée', type: 'PLUS', paied: false},
      start: this.incoherences.length > 0 ? this.incoherences[this.incoherences.length - 1].end : start,
      end: end,
      uid: end.getTime(),
      updated: false,
      type: 'INCOHERENCE_FREE',
      activityType: 'OFFSERVICE',
      duration: null,
      time: null,
      break: null
    };

    this.incoherences.forEach((inco, i) => {
      // console.log(123, moment(this.incoherences[i+1] && this.incoherences[i+1].start), inco.end);
      if (this.incoherences[i + 1] && Math.abs(moment(this.incoherences[i + 1].start).diff(moment(inco.end), 'minute')) > 5) {
        // console.log('enter push free incoherence')
        freeIncoherences.push({
          id: null,
          motif: {code: 'ARRIVEEANTICIPEE', label: 'Arrivée Anticipée', type: 'PLUS', paied: false},
          start: inco.end,
          end: this.incoherences[i + 1].start,
          uid: moment(inco.end).toDate().getTime(),
          updated: false,
          type: 'INCOHERENCE_FREE',
          activityType: 'OFFSERVICE',
          duration: null,
          time: null,
          break: null
        });
      }
    });
    if (this.incoherences.length > 0) {
      freeIncoherences.push(lastFreeIncoherence);
    }
    // console.log('freeIncoherences', freeIncoherences);
    this.incoherences = [...this.incoherences, ...freeIncoherences];
    this.incoherences = this.incoherences.map(inco => {
      inco.newMotif = this.motifMapper(inco);
      inco.motif = inco.newMotif != 'REALISE' && inco.newMotif != 'DELOG' ? inco.motif : inco.newMotif;
      if (inco.newMotif == 'PAUSE') {
        inco.durationBreak = moment(inco.end).diff(moment(inco.start), 'minute');
      }

      return inco;
    });
    // this.incoherences = this.incoherences.filter(e => ((e.type + '_' + e.activityType).toLowerCase().includes('incoherence')) || (e.start == undefined))
    this.incoherences = _.sortBy(this.incoherences, 'start');
    // this.incoherences = this.incoherences.filter((inco, i) => ((this.incoherences[i+1] && moment(this.incoherences[i+1].start).diff(inco.start, 'minute') != 0)))
    this.updateBlock.push(data.temps);
    // console.log('après ==================>', this.incoherences)
    // console.log('fusion blocks ==================>', this.fusionBlocks(this.incoherences))
    this.dataMotif = this.incoherences.map((d, i) => {
      const o = {};
      o[d.id] = d.motif;
      return o;
    });
    //this.incoherences = this.fusionBlocks(this.incoherences).filter(block => moment(block.end).diff(block.start, 'minute') > 5);
  }

  deleteFreeIncoherence(incoherence) {
    this.incoherences.splice(this.incoherences.indexOf(incoherence), 1);
  }

  ngOnInit() {
    const isupd = [];
    this.emit.getPopupEmitter().subscribe((item: Array<any>) => {
      console.log('incoherences after updateedee', this.incoherences);
      if (item.length > 0) {
        console.warn("On split:", item, this.index);
        if(this.index > -1) {
          this.incoherences.splice(this.index, 1);
          this.incoherences = this.incoherences.concat(item);
          this.incoherences = this.incoherences.map(e => {
            e.start = moment(e.start).format(DATE_TIME_FORMAT);
            e.end = moment(e.end).format(DATE_TIME_FORMAT);
            return e;
          });
          this.incoherences = _.sortBy(_.uniq(this.incoherences, 'start'), x => x.start);
          this.index = -1;
        }
/*        this.incoherences.forEach((d, i) => {
          if (d.id === item[0].id) {
            // if(item[0].motif && d.motif == 'DELOG'){
            //   d.uid = item[0].uid
            // }
            console.log('duid', d, d.uid, item.map(e => e.uid), item);
            if (item.map(e => e.uid).includes(d.uid)) {
              console.error('$$:', i, this.incoherences[i])
              this.incoherences.splice(i, 1);
            }
            this.incoherences = this.incoherences.concat(item);
            this.incoherences = this.incoherences.map(e => {
              e.start = moment(e.start).format(DATE_TIME_FORMAT);
              e.end = moment(e.end).format(DATE_TIME_FORMAT);
              return e;
            });
            this.incoherences = _.sortBy(_.uniq(this.incoherences, 'start'), x => x.start);
          }
        })*/;
        this.incoherences.forEach((d, i) => {
          if (d.updated) {
            isupd.push(d);
          }
        });
        this.isUpdated = (isupd.length > 0);
      }
      this.incoherences = _.sortBy(this.incoherences, 'start');
      this.incoherences = _.uniq(this.incoherences, x => x.start);
      console.log('incoherences start', this.incoherences, _);
    });
  }

  public CloseDialog() {
    this.dialogRef.close();
  }

  public setSizeDate(event: any, lefttime: any) {
    // console.log(event.srcElement.value, lefttime);
  }

  public getMinutes(v) {
    this.formatTime = moment.utc(v * 1000).format('HH:mm');
    return Math.floor(v / 60);
  }

  error(message: string) {
    this.alertService.error(message, 0);
  }

  checkBreakOverflowsMotifs() {
    let bos = this.incoherences.filter(i => i.start == undefined);
    let tmp = [];
    bos.forEach(bo => {
      let codeMotif = bo.motif.code;
      if (!tmp.includes(codeMotif)) {
        tmp.push(codeMotif);
      }
    });
    console.log('-------->', bos);
    return tmp.length === bos.length;
  }

  changeIncoherence(inco, event) {
    // console.log('inco', inco, 'event', event)
    console.log('incoherences before', this.incoherences);
    this.incoherences = this.incoherences.map(incoh => {
      if (incoh.uid == inco.uid) {
        incoh.newMotif = event.value;
        incoh.motif = {...incoh.newMotif};
        if (incoh.newMotif == 'PAUSE') {
          incoh.durationBreak = moment(incoh.end).diff(moment(incoh.start), 'minute');
        }
      }
      return incoh;
    });
    console.log('incoherences after update', this.incoherences);
  }

  insertBlocks() {
    console.log('this.incoherences', this.incoherences);
    const incoherences = JSON.parse(JSON.stringify(this.incoherences)).map(inco => {
      inco.start = this.tzService.LocaleToGmt(inco.start);
      inco.end = this.tzService.LocaleToGmt(inco.end);
      if (inco.newMotif == 'DELOG' || inco.newMotif == 'PAUSE') {
        inco.type = 'INCOHERENCE',
          inco.activityType = 'OFFSERVICE';
      }
      if (inco.newMotif == 'REALISE') {
        inco.type = 'FULFILLED',
          inco.activityType = 'INSERVICE';
      }
      inco.motif = {};
      // delete inco['motif'];
      return inco;
    });
    console.warn(incoherences);
    incoherences.forEach(e => {
      e.id = null;
      e.source = "DECLARATIVE";
    });

    this.blockservice.declarativeInjection(incoherences, false).subscribe(res => {
      res ? this.dialogRef.close(true) : '';
    });
    console.log('apres', incoherences);
  }

  public saveBlock() {
    if (!this.dateTimeRangeIsDisplayed) {
      let enterAllowed = true;
      const o = {inco: {'default': [], 'old': [], 'new': [], 'rm': [], 'motifs': []}, breaks: []};
      let data = [];
      this.incoherences.forEach((d, i) => {
        if (d.updated) {
          d.type = d.type.split('_')[0];
          data.push(d);
        }
      });

      o.breaks = this.incoherences.filter(d => d.start == undefined);
      let breakOverflows: any[] = [];
      o.breaks.forEach(breakOverflow => {
        breakOverflows.push({
          id: breakOverflow.id,
          pause: breakOverflow.break,
          duration: breakOverflow.duration,
          motif: breakOverflow.motif,
        });
      });
      if (!this.checkBreakOverflowsMotifs()) {
        this.error('Chaque dépassement de pause doit avoir un motif différent !');
        return;
      }
      if (breakOverflows.length > 0) {
        this.blockservice.putBreaks({breakOverflows: breakOverflows}, () => {
          this.enableButton = true;
          /**
           * =============== Close Popup
           * */

          if (localStorage.getItem('divBlock') == '1') {
            this.CloseDialog();
          }
          this.emit.emithBlock(localStorage.getItem('usernameEdit'));
        });
      }
      if (data.length == 0) {
        this.CloseDialog();
        return;
      } else {
        this.emit.emithBlock(localStorage.getItem('usernameEdit'));
        this.enableButton = false;

        window['root'].registerListener((newBlock) => {
          if (enterAllowed) {
            console.log(newBlock);
            this.blockservice.checkLockedShift(newBlock.user).subscribe((details: any) => {
              console.log('checkLockedShift response', details);
              this.lockUser = details && details.createdBy;
              this.isUpdatedBlocks = details && details.locked;
              if (details && details.locked) {
                return;
              }
              /**
               * ========================== get block updated
               */
              o.inco.motifs = [];
              o.inco.old = [];
              o.inco.new = [];
              o.inco.rm = [];
              o.inco.old = JSON.parse(JSON.stringify(this.incoherencesOld));
              this.isUpdatedBlocks = false;

              data = data.map((d, i) => {
                if (data[i].type != 'undefined') {
                  data[i].start = this.tzService.LocaleToGmt(data[i].start);
                  data[i].end = this.tzService.LocaleToGmt(data[i].end);
                }
                return d;
              });
              let _default = JSON.parse(JSON.stringify(data.filter(d => d.start !== undefined)));
              o.inco.new = data.filter(d => d.start !== undefined).map((e) => {
                //e.id = null;
                return e;
              });
              let _copyBlock = [].concat(o.inco.old.filter(d => data.map(e => e.id).indexOf(d.id) == -1));
              o.inco.new = o.inco.new.concat(_copyBlock).map((e) => {
                // e.id = null;
                return e;
              });
              // for inco
              o.inco.new = JSON.parse(JSON.stringify(o.inco.new));


              /**
               * ================== Check Version Block
               * */
              if (localStorage.getItem('divBlock') == '0') {
                let realTimeold = newBlock.temps_data.filter(e => ['FULFILLED_INCOHERENCE'].indexOf(e.name) > -1);
                realTimeold = realTimeold
                  .filter(e => e.tag.toLowerCase() === 'incoherence')
                  .filter(e => ['SEUILMOINS', 'SEUILPLUS'].indexOf(e.motif.code) === -1);
                console.log(':::', realTimeold);
                // get Exclude block
                let exclude = [];
                let _oldids = [];
                exclude = realTimeold.map(e => e.id);
                _oldids = this.incoherencesOld.map(m => m.id);
                if (_oldids.length > exclude.length) {
                  _oldids = realTimeold.map(e => e.id);
                  exclude = this.incoherencesOld.map(m => m.id);
                }
                let t = [];
                _oldids.forEach((v) => {
                  if (exclude.indexOf(v) == -1) {
                    t.push(v);
                  }
                });
                console.log('===========================================');
                console.log(t);
                console.log('===========================================');

                o.inco.rm = realTimeold.filter(e => t.indexOf(e.id) > -1 && e.blockStatus != 'VALIDATED');
                let checkOld = JSON.parse(JSON.stringify(this.incoherencesOld));
                let _rt = realTimeold;
                let _cd = checkOld;
                if (checkOld.length > realTimeold.length) {
                  _cd = realTimeold;
                  _rt = checkOld;
                }
                _rt.forEach(function (_n) {
                  _cd.forEach(function (_old) {
                    if (_n.motif && _old.motif) {
                      if (_old.id == _n.id) {
                        if (_old.motif.code !== _n.motif.code) {
                          o.inco.motifs.push(_n);
                        }
                      }
                    }
                  });
                });
                //          o.inco.old = realTimeold;
                console.log(o.inco);
                if (o.inco.rm.length > 0 || o.inco.motifs.length > 0) {
                  this.isUpdatedBlocks = true;
                  this.enableButton = true;
                } else {
                  this.isUpdatedBlocks = false;
                  this.blockservice.putBlock(_default, () => {
                    this.isUpdatedBlocks = false;
                    this.enableButton = true;
                    /**
                     * =============== Close Popup
                     * */

                    if (localStorage.getItem('divBlock') == '1') {
                      this.CloseDialog();
                    }
                    this.emit.emithBlock(localStorage.getItem('usernameEdit'));
                  });
                }
                console.error('>>> ', data);
                localStorage.setItem('divBlock', '1');
              }
              console.log('Someone changed the value of new Block', newBlock);
            });
          }
          enterAllowed = false;
        });

      }
    }
  }

  getCurrentOnEdit(event: any) {
    let index = -1;
    this.incoherences.find((inco, i) => {
      if(moment(inco.start).format(DATE_TIME_FORMAT) == event.start && moment(inco.end).format(DATE_TIME_FORMAT) == event.end) {
        index = i;
      }
    });
    this.index = index;
  }
  dateTimeRangeDisplayFunc(event) {
    this.dateTimeRangeIsDisplayed = event;
  }

  public UpdateMotif(id: any) {
    this.alertService.clear();
    this.incoherences.forEach((d, i) => {
      if (d.uid === id) {
        // console.log(this.incoherences[i])
        this.incoherences[i]['updated'] = true;
      }
      return d;
    });
  }

  motifMapper(incoherence) {
    console.log('incoherence', incoherence);
    if (incoherence.type == 'INCOHERENCE_FREE') {
      return this.motifExeception[1].code;
    }
    if (incoherence.motif && incoherence.motif.type == 'PLUS' || incoherence.type == 'FULFILLED_INSERVICE') {
      return this.motifExeception[2].code;
    }
    if (incoherence.motif && incoherence.motif.type == 'MINUS') {
      return null;
    }
    return incoherence.motif;
  }

  fusionBlocks(blocks: any) {
    return blocks.map((block) => {
      // console.log('first block', block)
      const nextBlocks: any = blocks
        .filter(nxBlock => block.uid != nxBlock.uid && moment(nxBlock.start).isSameOrAfter(block.start));
      for (const key in nextBlocks) {
        // console.log('enter nextblocks loop', nextBlocks[key]);
        if (nextBlocks[key] && block.newMotif && block.newMotif == nextBlocks[key].newMotif) {
          block.end = nextBlocks[key].end;
          // console.log('new Block', block)
          blocks.splice(key, 1);
        } else {
          break;
        }
      }
      ;
      return {...block};
    });
  }


  public splitBreak(uid, el) {
    this.incoherences.forEach((d, i) => {
      if (d.uid === uid) {
        console.log('4', uid, el);
        let cp = Object.assign({}, d);
        ;
        const o = d.duration;
        const n = (el.value * 60);
        if (n < d.duration) {
          d.duration = n;
          d['updated'] = true;
          if ((o - n) > 0) {
            const user = JSON.parse(localStorage.getItem('INTELCIA_OAUTH_REMOTE_USER'));
            this.incoherences.push({
              id: new Date().getTime(),
              uid: new Date().getTime(),
              motif: {'code': d.motif.code, 'label': d.motif.label, 'type': d.motif.type},
              type: d.type,
              duration: (o - n),
              updated: true,
              updatedBy: (user ? user.username : null),
              'break': d.break
            });
            /*const user = JSON.parse(localStorage.getItem('INTELCIA_OAUTH_REMOTE_USER'));
              let vo = {
                id: new Date().getTime(),
                uid: new Date().getTime(),
                type: d.type,
                activityType: d.activityType,
                blockStatus: d.blockStatus,
                label: d.label,
                timeZone: d.timeZone,
                user: d.user,
                logged: d.logged,
                tag: d.tag,
                durationBreak: d.durationBreak,
                validatedBy: d.validatedBy,
                reclamationStatus: d.reclamationStatus,
                source: d.source,
                motif: {'code': d.motif.code, 'label': d.motif.label, 'type': d.motif.type},
                duration: (o  -  n),
                updated: true,
                updatedBy: (user ? user.username : null),
                'break': d.break
            }
            this.incoherences.push(o);*/
          }
        }
      }
    });
  }

  refreshBlock() {
    this.dialogRef.close();
    this.dialogRef.afterClosed().subscribe(() => {
      let el = document.querySelector('.dataset .INCOHERENCE_OFF');
      if (!el) {
        el = document.querySelector('.dataset .INCOHERENCE_ON');
      }
      setTimeout(() => {
        el.dispatchEvent(new Event('click'));
      }, 100);
    });
  }

  getIncos() {
    return [...this.incoherences];
  }

  addBlock() {

  }

  rmInco(i: any) {
    const removed = this.incoherences[i];
    let before = this.incoherences[i - 1];
    if (before) {
      before.end = removed.end;
      this.incoherences[i - 1] = before;
    }
    this.incoherences = this.incoherences.filter((e, g) => g !== i);
  }

  generateUUID(start, end) {
    return [start, end]
        .map((e: any) => String(e)
        .split('')
        .map((e: any) => String(e).charCodeAt(null))
        .reduce((p, c) => p + c, 0))
        .reduce((p, c) => p + c, 0)
  }
}



// WEBPACK FOOTER //
// ./src/app/view/Insert-realise-dialog/insert-realise-dialog.component.ts